import { render } from "./MenuWine.vue?vue&type=template&id=c80e8602"
import script from "./MenuWine.vue?vue&type=script&lang=js"
export * from "./MenuWine.vue?vue&type=script&lang=js"

import "./MenuWine.vue?vue&type=style&index=0&id=c80e8602&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__